import type { CompletionOption } from '@sancare-commons/components/types'
import type { StringKeys } from '@sancare-commons/misc/string-utils'


export function UseMapToCompletionOptions<T>(
  list: T[],
  titleProp: StringKeys<T>,
  descriptionProp: StringKeys<T>,
  keyProp: StringKeys<T>
): CompletionOption<T>[] {
  return list.map((item) => ({
    title: item[titleProp] as string,
    description: item[descriptionProp] as string,
    key: item[keyProp] as string,
    value: item
  }))
}